var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3721_23390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3721_23390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 78.3984C18.5 78.3983 15.8333 92.0651 5 100.898C78.5 143.398 119.5 100.898 112.5 94.8986C105.5 88.8987 98.5 94.8986 93 94.8986C87.5 94.8986 72.9513 78.3985 55 78.3984Z",
    fill: "#093E62"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3721_23390)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8143 34.0576L47.931 42.2225L49.3628 45.5196L33.5732 34.5552",
    fill: "#093E62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2822 19.9561L51.8245 40.9864L54.2607 88.0003H47.2371L49.392 41.2352L44.2822 19.9561Z",
    fill: "#093E62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3428 14.6053C47.4122 19.4322 39.9831 19.4322 40.0379 14.6053C39.9831 9.79694 47.4122 9.79694 47.3428 14.6053Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7474 12.5781C47.7774 16.5102 42.1892 18.8716 40.1475 15.4557C41.5865 20.9732 49.6877 17.4718 46.7474 12.5781Z",
    fill: "#2974B2"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8316 20.1044C51.89 24.2852 45.4325 24.2852 45.4946 20.1044C45.4325 15.9235 51.8937 15.9235 51.8316 20.1044Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3166 18.3447C52.2115 21.7607 47.3537 23.814 45.5786 20.8436C46.8278 25.6408 53.8733 22.5961 51.3166 18.3447Z",
    fill: "#2974B2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4766 16.8104C55.5351 20.9913 49.0775 20.9913 49.1396 16.8104C49.0775 12.6296 55.5387 12.6296 55.4766 16.8104Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9616 15.0508C55.8565 18.4667 50.9987 20.52 49.2236 17.5459C50.4728 22.3468 57.5184 19.3022 54.9616 15.0508Z",
    fill: "#2974B2"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7364 20.1639C46.7109 25.5477 38.6572 25.5477 38.6353 20.1639C38.6134 14.78 46.7109 14.78 46.7364 20.1639Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0753 17.9141C47.2186 22.2805 41.0094 24.9019 38.7412 21.1072C40.341 27.2374 49.3406 23.3499 46.0753 17.9141Z",
    fill: "#2974B2"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4816 17.4867C42.4561 23.4275 33.5989 23.4275 33.5733 17.4867C33.5477 11.5459 42.4561 11.5645 42.4816 17.4867Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7546 15.0098C43.0147 19.8144 36.1846 22.6994 33.6899 18.5223C35.4468 25.2688 45.3486 20.9914 41.7546 15.0098Z",
    fill: "#2974B2"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1889 15.8269C51.251 20.1006 44.6473 20.1006 44.7094 15.8269C44.6473 11.5681 51.251 11.5681 51.1889 15.8269Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6627 14.041C51.5795 17.5312 46.6121 19.6328 44.7969 16.5956C46.0752 21.5004 53.2742 18.3889 50.6627 14.041Z",
    fill: "#2974B2"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3488 61.0293L51.4043 72.9034L51.565 76.234L69.3488 61.0293Z",
    fill: "#093E62"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0177 43.9607L51.8242 56.5737L52.0689 61.2743L66.8285 43.0176",
    fill: "#093E62"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9497 46.1914L50.6083 66.223V62.0162L38.9497 46.1914Z",
    fill: "#093E62"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5571 45.8018L45.0493 55.8046L47.2408 59.7032L31.5571 45.8018Z",
    fill: "#093E62"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1146 43.1548C40.1766 47.5733 33.3539 47.5733 33.4159 43.1548C33.3539 38.7401 40.1766 38.7401 40.1146 43.1548Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.567 41.2939C40.5166 44.903 35.3812 47.0714 33.4966 43.9339C34.8261 49.0021 42.2625 45.7867 39.567 41.2939Z",
    fill: "#2974B2"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5777 45.0445C44.6435 49.4629 37.8171 49.4629 37.8828 45.0445C37.8171 40.6297 44.6435 40.6297 44.5777 45.0445Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0338 43.1846C44.9798 46.7936 39.8444 48.9657 37.9707 45.8245C39.2929 50.8965 46.7329 47.681 44.0338 43.1846Z",
    fill: "#2974B2"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2385 48.2084C44.2932 52.0476 38.358 52.0476 38.4164 48.2084C38.3617 44.3654 44.2932 44.3654 44.2385 48.2084Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7637 46.5889C44.5855 49.7263 40.1112 51.6125 38.4932 48.8835C39.64 53.2908 46.1122 50.4949 43.7637 46.5889Z",
    fill: "#2974B2"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4816 42.1887C42.5364 46.0279 36.6048 46.0279 36.6596 42.1887C36.6048 38.342 42.54 38.342 42.4816 42.1887Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0068 40.5664C42.8323 43.7039 38.3544 45.5901 36.7363 42.861C37.8795 47.2684 44.3553 44.4725 42.0068 40.5664Z",
    fill: "#2974B2"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8995 41.2906C35.9543 45.1298 30.0227 45.1298 30.0775 41.2906C30.0227 37.4513 35.9543 37.4513 35.8995 41.2906Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4248 39.6719C36.2502 42.8131 31.7723 44.6993 30.1543 41.9702C31.3048 46.3775 37.7733 43.5817 35.4248 39.6719Z",
    fill: "#2974B2"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5559 48.2597C39.6253 53.1683 32.0428 53.1683 32.1159 48.2597C32.0355 43.3548 39.6253 43.3548 39.5559 48.2597Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9495 46.1914C40.0014 50.2014 34.2963 52.6149 32.2144 49.1247C33.6826 54.7573 41.9518 51.1854 38.9495 46.1914Z",
    fill: "#2974B2"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6476 45.8023C35.6257 51.2418 27.488 51.2418 27.4625 45.8023C27.4369 40.3628 35.6257 40.3628 35.6476 45.8023Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9831 43.5254C36.1409 47.9401 29.8697 50.5801 27.5723 46.752C29.1867 52.9564 38.2849 49.0206 34.9831 43.5254Z",
    fill: "#2974B2"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1006 43.459L57.9092 52.3665L55.9624 54.5942L60.1006 43.459Z",
    fill: "#093E62"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5088 60.2861L60.2618 67.9238L58.0703 69.4572L63.5088 60.2861Z",
    fill: "#093E62"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3552 56.1838C68.421 60.6803 61.4704 60.6803 61.5361 56.1838C61.474 51.6874 68.421 51.6874 68.3552 56.1838Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8001 54.29C68.7643 57.9659 63.5377 60.1714 61.6274 56.9782C62.9715 62.1393 70.5504 58.8644 67.8001 54.29Z",
    fill: "#2974B2"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5558 61.3257C72.6106 65.2355 66.5694 65.2355 66.6279 61.3257C66.5694 57.4123 72.6106 57.4123 72.5558 61.3257Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.07 59.6777C72.9101 62.8746 68.3665 64.7942 66.7046 62.0169C67.8734 66.5059 74.4624 63.6581 72.07 59.6777Z",
    fill: "#2974B2"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9635 58.2478C76.0183 62.1575 69.9771 62.1575 70.0356 58.2478C69.9808 54.338 76.022 54.338 75.9635 58.2478Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 56.5996C76.3361 59.7928 71.7925 61.7161 70.1343 58.9351C71.2848 63.4241 77.8738 60.5762 75.4997 56.5996Z",
    fill: "#2974B2"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7893 61.3816C67.7638 66.4201 60.2324 66.4164 60.2105 61.3816C60.1886 56.3468 67.7674 56.3468 67.7893 61.3816Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1718 59.2686C68.242 63.3528 62.4236 65.8071 60.3125 62.2389C61.8064 67.9978 70.2253 64.3628 67.1718 59.2686Z",
    fill: "#2974B2"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.812 58.8974C63.7864 64.4372 55.499 64.4372 55.4771 58.8974C55.4552 53.3576 63.7864 53.3279 63.812 58.8974Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1324 56.5625C64.3085 61.0552 57.9203 63.7546 55.5864 59.8485C57.2373 66.1569 66.4927 62.158 63.1324 56.5625Z",
    fill: "#2974B2"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9529 57.3386C72.0113 61.3375 65.835 61.3375 65.8935 57.3386C65.835 53.3285 72.0113 53.3285 71.9529 57.3386Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4601 55.6562C72.3185 58.92 67.6725 60.8841 65.9814 58.0437C67.1685 62.633 73.9073 59.722 71.4601 55.6562Z",
    fill: "#2974B2"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7363 31.3359C46.8719 37.5738 45.2027 36.0069 51.7589 45.9911L51.3535 50.8811L44.779 38.0156L36.7363 31.3359Z",
    fill: "#093E62"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2488 27.523C39.2232 32.8882 31.2134 32.8882 31.1769 27.523C31.1404 22.1577 39.2232 22.1577 39.2488 27.523Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6096 25.2803C39.7492 29.6319 33.5619 32.2458 31.3047 28.4623C32.8752 34.5739 41.8457 30.6975 38.6096 25.2803Z",
    fill: "#2974B2"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2202 33.6122C44.2859 38.2386 37.1344 38.2386 37.2002 33.6122C37.149 28.9821 44.2859 28.9821 44.2202 33.6122Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6465 31.6592C44.64 35.4427 39.2599 37.7336 37.2949 34.4291C38.6792 39.7424 46.4772 36.371 43.6465 31.6592Z",
    fill: "#2974B2"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2559 29.9657C48.3216 34.5921 41.1701 34.5921 41.2359 29.9657C41.1665 25.3356 48.3216 25.3356 48.2559 29.9657Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6827 28.0127C48.6761 31.7962 43.2997 34.0686 41.3311 30.7789C42.7153 36.0922 50.5133 32.7245 47.6827 28.0127Z",
    fill: "#2974B2"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5769 33.6786C38.5477 39.6194 29.6321 39.6194 29.6065 33.6786C29.5809 27.7379 38.5514 27.7082 38.5769 33.6786Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.843 31.1836C39.1141 36.0105 32.2365 38.9252 29.7236 34.7184C31.4951 41.5094 41.4626 37.2024 37.843 31.1836Z",
    fill: "#2974B2"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8616 30.7128C33.8324 37.2736 24.0256 37.2736 24 30.7128C24.0292 24.1556 33.8397 24.1556 33.8616 30.7128Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0616 27.9717C34.4568 33.2775 26.8926 36.4856 24.1313 31.8592C26.1913 39.3371 36.9697 34.6736 33.0616 27.9717Z",
    fill: "#2974B2"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5079 28.8896C43.5773 33.6236 36.2651 33.6236 36.3345 28.8896C36.2651 24.1592 43.5773 24.1592 43.5079 28.8896Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9235 26.8955C43.9389 30.7644 38.4383 33.0888 36.4185 29.7248C37.8429 35.1569 45.8199 31.7113 42.9235 26.8955Z",
    fill: "#2974B2"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3454 24.4081L51.6708 45.2974L50.6079 42.7169L59.8559 24.1631L60.3454 24.4081Z",
    fill: "#093E62"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0752 21.9724L56.2805 32.6843L55.2322 35.0495L53.7749 21.4414L55.0752 21.9724Z",
    fill: "#093E62"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4803 18.9645C64.4548 24.7902 55.7436 24.7902 55.7144 18.9645C55.6852 13.1389 64.4584 13.1426 64.4803 18.9645Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7681 16.5283C65.0063 21.2512 58.2894 24.0917 55.835 19.9851C57.5662 26.6165 67.3037 22.4097 63.7681 16.5283Z",
    fill: "#2974B2"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3241 21.4411C70.2985 27.2631 61.5874 27.2631 61.5582 21.4411C61.529 15.6191 70.2985 15.6154 70.3241 21.4411Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6082 19.0049C70.8464 23.7278 64.1295 26.5645 61.6787 22.458C63.4063 29.0931 73.1438 24.8863 69.6082 19.0049Z",
    fill: "#2974B2"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8783 25.5734C69.8564 30.6379 62.2812 30.6379 62.2593 25.5734C62.2374 20.5088 69.8564 20.5126 69.8783 25.5734Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2577 23.457C70.3534 27.5636 64.5095 30.0327 62.3618 26.4608C63.863 32.2271 72.3294 28.5698 69.2577 23.457Z",
    fill: "#2974B2"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7536 25.6475C63.7243 32.1192 54.0453 32.1155 54.0161 25.6475C54.0453 19.1683 63.7243 19.1683 63.7536 25.6475Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9572 22.9414C64.3342 28.1879 56.8722 31.3402 54.1475 26.7769C56.1746 34.1546 66.8142 29.5654 62.9572 22.9414Z",
    fill: "#2974B2"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6397 22.4282C58.6104 29.5646 47.9635 29.5646 47.9307 22.4282C47.9635 15.3104 58.6104 15.3104 58.6397 22.4282Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7669 19.4541C59.2826 25.2241 51.0719 28.6957 48.0732 23.6758C50.2976 31.7924 62.0074 26.7278 57.7669 19.4541Z",
    fill: "#2974B2"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6687 35.9515C67.6395 42.8985 57.2373 42.8985 57.2373 35.9515C57.2373 29.0045 67.6395 29.0045 67.6687 35.9515Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8178 33.0479C68.2788 38.6805 60.2835 42.063 57.3579 37.1656C59.5384 45.0817 70.956 40.1471 66.8178 33.0479Z",
    fill: "#2974B2"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9043 42.4343C74.9043 48.6425 65.6344 48.7093 65.565 42.5012C65.5503 36.293 74.8349 36.2262 74.9043 42.4343Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1262 39.8428C75.4995 44.8664 68.3407 47.9445 65.6963 43.5855C67.6905 50.6476 77.8663 46.1623 74.1262 39.8428Z",
    fill: "#2974B2"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7996 43.9194C66.7631 51.635 55.2213 51.635 55.1885 43.9194C55.2213 36.2001 66.7668 36.2001 66.7996 43.9194Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8536 40.7041C67.3986 47.0162 58.7167 50.7292 55.3418 45.2674C57.7634 54.0709 70.452 48.5794 65.8536 40.7041Z",
    fill: "#2974B2"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4872 41.818C59.3411 50.3579 46.857 50.3579 46.7036 41.818C46.857 33.2781 59.3448 33.2781 59.4872 41.818Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4462 38.2646C60.1593 45.2302 50.5935 49.2848 46.8862 43.3032C49.5452 52.9755 63.5049 46.9419 58.4462 38.2646Z",
    fill: "#2974B2"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9431 36.4378C72.9139 42.7871 63.4211 42.7833 63.3956 36.4378C63.37 30.0923 72.9431 30.0923 72.9431 36.4378Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1793 33.7832C73.5307 38.9294 66.2112 42.026 63.5376 37.5482C65.5245 44.7885 75.9633 40.2735 72.1793 33.7832Z",
    fill: "#2974B2"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5869 36.2487C60.5577 42.8244 50.7253 42.8244 50.6924 36.2487C50.7216 29.6619 60.5613 29.6619 60.5869 36.2487Z",
    fill: "#2974B2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7939 33.4863C61.1928 38.8219 53.6067 42.0262 50.8345 37.3887C52.8872 44.8852 63.6984 40.2106 59.7939 33.4863Z",
    fill: "#2974B2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3721_23390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 77,
    fill: "white",
    transform: "translate(24 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTree);
export default __webpack_public_path__ + "static/media/imgTree.eea3d6f03acaf876984595394221194b.svg";
export { ForwardRef as ReactComponent };